import { ATTENDANCE_STATUSES } from './enums';
/** Kırılım OKUNMADAN çipe sayı yazılmaz; sıfırlar yalnız başlangıç değeridir. */
export const EMPTY_ATTENDANCE_STATUS_COUNTS = Object.freeze(Object.fromEntries(ATTENDANCE_STATUSES.map((status) => [status, 0])));
/** "Tümü" çipinin sayısı: kırılımın TOPLAMI (satırlardan değil sunucudan). */
export function totalAttendanceCount(counts) {
    return ATTENDANCE_STATUSES.reduce((sum, status) => sum + counts[status], 0);
}
//# sourceMappingURL=attendance-counts.js.map